import { dataMapRef } from './consts';

export default function(editor, opts = {}) {
  const c = opts;
  const bm = editor.BlockManager;
  const style = `
  <style>
  .data-map div.map {
    position: revert !important;
   }
  div.data-map {
   width: 100%;
   height: 100%;
  }
  </style>
  `;
  if (c.blocks.indexOf(dataMapRef) >= 0) {
    bm.add(dataMapRef, {
      label: `<i class="webconnect-google-maps"></i><div>${c.labelMap}</div>`,
      category: c.labelMapCategory,
      content: `<div class="${dataMapRef}" role="${dataMapRef}" data-gjs-type="${dataMapRef}" data-gjs="${dataMapRef}">
          ${style}
      </div>`,
    });
  }
}
